import React from 'react';
import Container from "../../Wrappers/Container";
import AddActionButton from "../../Atoms/Buttons/AddActionButton";
import PayrollNote from "../../Molecules/PayrollNote";
import AccordionWrapper from "../../Wrappers/AccordionWrapper";
import NoteBoard from '../../../static/images/stories/note-board.svg'
import NotesPayrollEmptyState from "../Emptys/NotesPayrollEmptyState";

const NotesPayrollPanel = () => {
  return (
    <Container className="lg-y-1 lg-x-4 s-rows-2">
      <div className="s-main-justify s-cross-center s-mb-8px">
        <h3 className="s-mb-0">Notas</h3>
        {/* Mostrar sólo cuando ya haya notas creadas */}
        <AddActionButton />
      </div>
      <div className="ed-grid row-gap s-gap-1">
        <AccordionWrapper defaultActive={0}>
          <PayrollNote
            index={0}
            note={{
              title: 'Contratar más personal para marketing',
              content: 'Contratar más personal para el área de marketing',
              date: '10 de agosto del 2020',
            }}
          />
          <PayrollNote
            index={1}
            note={{
              title: 'Renovar contratos',
              content: 'Contratar más personal para el área de marketing',
              date: '10 de agosto del 2020',
            }}
          />
          <PayrollNote
            index={2}
            note={{
              title: 'Liquidar nómina',
              content: 'Contratar más personal para el área de marketing',
              date: '10 de agosto del 2020',
            }}
          />
          <PayrollNote
            index={3}
            note={{
              title: 'Liquidar nómina',
              content: 'Contratar más personal para el área de marketing',
              date: '10 de agosto del 2020',
            }}
          />
        </AccordionWrapper>
      </div>
      {/*<NotesPayrollEmptyState />*/}
    </Container>
  );
};

export default NotesPayrollPanel;
